import React, { HTMLAttributes, ReactNode } from 'react';

import classNames from 'classnames';

import { LinkI18n } from '@/i18n/routing';

import styles from './styles.module.scss';

const sizes = {
  xs: styles.sizeXS,
  s: styles.sizeS,
  m: styles.sizeM,
  responsiveXM: styles.sizeResponsiveXM,
};

type LinkProps = Parameters<typeof LinkI18n>[0];

type Props = {
  text: ReactNode;
  icon: ReactNode;
  size?: keyof typeof sizes;
  href?: LinkProps['href'];
} & HTMLAttributes<HTMLElement>;

export const CurrencyBadge = ({ icon, text, size = 's', href, className, ...other }: Props) => {
  const Wrapper = href ? LinkI18n : 'div';

  return (
    <Wrapper href={href!} className={classNames(styles.currencyBadge, sizes[size], className)} {...other}>
      <div className={styles.iconWrapper}>{icon}</div>
      <span>{text}</span>
    </Wrapper>
  );
};
